

const actions={
	changeMsgCount({commit},msgCount){
		commit('changeMsgCount',msgCount)
		sessionStorage.setItem('msgCount', msgCount)
	},
	changeUserName({commit},userName){
		commit('changeUserName',userName)
		sessionStorage.setItem('userName', userName)
	}
	
}


export default actions


// WEBPACK FOOTER //
// ./src/_vuex/actions.js